import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement>;

export const ClockIcon = (props: Props) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    return (
        <svg width={scaleWidthPixel(17)} height={scaleHeightPixel(16)} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_5610_26507)">
                <g clipPath="url(#clip1_5610_26507)">
                    <path
                        d="M13.2175 2.64957C10.3475 -0.22043 5.68754 -0.22043 2.81754 2.64957C-0.0524609 5.51957 -0.0524609 10.1796 2.81754 13.0496C5.68754 15.9196 10.3475 15.9196 13.2175 13.0496C14.5975 11.6696 15.3775 9.79957 15.3675 7.84957C15.3675 5.89957 14.5975 4.02957 13.2175 2.64957V2.64957ZM8.01754 14.7296C4.21754 14.7296 1.14754 11.6496 1.14754 7.85957C1.14754 4.06957 4.21754 0.97957 8.01754 0.97957C11.8175 0.97957 14.8875 4.05957 14.8875 7.84957C14.8875 11.6496 11.8075 14.7196 8.01754 14.7196V14.7296ZM12.3475 7.61957H8.25754V2.30957C8.25754 2.17957 8.14754 2.06957 8.01754 2.06957C7.88754 2.06957 7.77754 2.17957 7.77754 2.30957V7.85957C7.77754 7.98957 7.88754 8.09957 8.01754 8.09957H12.3475C12.4775 8.09957 12.5875 7.98957 12.5875 7.85957C12.5875 7.72957 12.4775 7.61957 12.3475 7.61957V7.61957Z"
                        stroke="currentColor"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_5610_26507">
                    <rect width={scaleWidthPixel(16)} height={scaleHeightPixel(16)} fill="white" transform="translate(0.157715)" />
                </clipPath>
                <clipPath id="clip1_5610_26507">
                    <rect width={scaleWidthPixel(15.71)} height={scaleHeightPixel(15.71)} fill="white" transform="translate(0.157715)" />
                </clipPath>
            </defs>
        </svg>
    );
};
